import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { backend } from '@shared/datastore/core';
import { searchMyContactsBackend } from './search-my-contacts.backend';
// import { DatastoreBackendModule } from '@shared/datastore/core';
import { searchMyContactsReducer } from './search-my-contacts.reducer';

// FIXME: remove that
backend.searchMyContacts = searchMyContactsBackend;

@NgModule({
  imports: [
    StoreModule.forFeature('searchMyContacts', searchMyContactsReducer),
    /* DatastoreBackendModule.forFeature(
      'searchMyContacts',
      searchMyContactsBackend,
    ),*/
  ],
})
export class DatastoreSearchMyContactsModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/search-my-contacts/search-my-contacts.module.ts